import React from 'react';
import { AppReactContext, IAppContext } from '../../AppContext';

// eslint-disable-next-line import/no-named-as-default-member
class Logout extends React.Component<any, any> {
  context!: React.ContextType<typeof AppReactContext>;

  async componentDidMount (): Promise<void> {
    const appContext: IAppContext = this.context;
    const authService = appContext.AuthService;
    await authService.logout();
  }

  render () {
    return (
      <div>Logging out...</div>
    );
  }
}

Logout.contextType = AppReactContext;

export default Logout;
